export default {
    appBar: {
        boxShadow: "0px 15px 19px rgba(47, 65, 81, 0.04)",
        padding: "22px 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    logo: {
        height: "22px",
        marginRight: "auto",
    },
    formContainer: {
        display: "inline-block",
        height: "100vh",
        width: "50%",
        backgroundColor: "white",
    },
    contenidoPrincipal: {
        marginTop: "100px",
    },
    form: {
        marginTop: "15px",
    },
    title: {
        fontWeight: "500",
        marginBottom: "20px",
    },
    imagen: {
        display: "inline-block",
        height: "100vh",
        width: "50%",
        "& img": {
            objectFit: "cover",
            height: "100%",
            width: "100%",
        },
    },
};
